"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles/app.css");
require("./styles/header.css");
require("./styles/content.css");
require("./styles/footer.css");
